import React, { useState } from "react";
import { makeRequest } from "../../../assets/functions_helper";
import ListData from "../../../components/listData";
import {
  Box,
  Button,
  Snackbar,
  Switch,
  Typography,
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { IconButtonAnimated } from "../../../components/resources";
import CloseIcon from "@mui/icons-material/Close";
import ListUsersRestaurants from "./list_users_restaurant";
import ListTablesRestaurant from "./list_tables_restaurant";
import { useNavigate } from "react-router-dom";
import CustomTabs from "../../../components/customTabs";
import ArrowCircleLeft from "../../../assets/images/arrow_circle_left.png";
import { SendButton } from "../../../components/buttons";
import {
  CustomDialog,
  CustomDialogActions,
  CustomDialogContent,
  CustomDialogTitle,
} from "../../../components/customDialog";
import MenuRestaurant from "./menu_restaurant";
import ListProducts from "./menu_components/list_products";
import WeeklyMenuScheduler from "./menu_components/scheduler";
import EditIcon from "../../../assets/images/door.png";
import { Breadcrumbs, Link } from "@mui/material";
import ListImages from "./list_pool_images";
import ListCategories from "./menu_components/list_categories";
import RestaurantSettings from "./restaurants_settings_components/settings";
import CreateRestaurantModal from "./CreateRestaurantModal";
import DeleteRestaurantModal from "./DeleteRestaurantModal";

// El backend puede enviar "is_owner" = "true", pero por defecto el rol "2" significa dueño.
const isAccountOwner = () => localStorage.getItem("is_owner") === "true" || localStorage.getItem("rol") === "2";

function ListRestaurants({
  restaurants,
  setRestaurants,
  total,
  setTotal,
  pages,
  setPages,
  currentPage,
  setCurrentPage,
  isLoaded,
  setIsLoaded,
}) {
  const [page, setPage] = useState(1);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [messageSnackBar, setMessageSnackBar] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [restaurantId, setRestaurantId] = useState("");
  const [nameRestaurant, setNameRestaurant] = useState("");
  const [openModalCode, setOpenModalCode] = useState(false);
  const [codeDay, setCodeDay] = useState("");
  const [isOn, setIsOn] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingValue, setPendingValue] = useState(null);

  // ── Nuevos modales ────────────────────────────────────────────────────────
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const ownerMode = isAccountOwner(); // solo true si is_owner === "true"

  const tabs = [
    {
      label: "Administradores",
      content: (
        <ListUsersRestaurants
          idRestaurant={`${restaurantId}`}
          role={[2]}
          title={``}
          titleContent={"Asigna un administrador al restaurante"}
          titleCreate={"Crear"}
          nameColumn1="Nombre"
          nameColumn2="Correo"
          nameColumn3="Acciones"
          nameOfRestaurant={nameRestaurant}
        />
      ),
    },
    {
      label: "Meseros",
      content: (
        <ListUsersRestaurants
          idRestaurant={restaurantId}
          role={[3, 4]}
          title={``}
          titleContent={`Asigna un mesero al restaurante`}
          titleCreate={"Crear"}
          nameColumn1="Nombre"
          nameColumn2="Correo"
          nameColumn3="Acciones"
          nameOfRestaurant={nameRestaurant}
          waiters={true}
        />
      ),
    },
    {
      label: "Mesas",
      content: (
        <ListTablesRestaurant
          idTable={restaurantId}
          title={`Mesas`}
          titleContent={`Crea una mesa para el restaurante`}
          titleCreate={"Crear Mesas"}
          nameColumn1="Mesas"
          nameColumn3="Acciones"
          nameOfRestaurant={nameRestaurant}
        />
      ),
    },
    {
      label: "Menu",
      content: <MenuRestaurant restaurantId={restaurantId} />,
    },
    {
      label: "Productos",
      content: <ListProducts restaurantId={restaurantId} />,
    },
    {
      label: "Categorias",
      content: <ListCategories restaurantId={restaurantId} />,
    },
    {
      label: "Agenda",
      content: <WeeklyMenuScheduler />,
    },
    {
      label: "Imagenes",
      content: <ListImages restaurantId={restaurantId} />,
    },
    {
      label: "Ajustes",
      content: <RestaurantSettings restaurantId={restaurantId} />,
    },
  ];

  const navigate = useNavigate();

  const ChangePage = (value) => {
    let url;
    // Asumiendo que `rol` es el estado o prop que contiene el valor del rol actual
    if (localStorage.getItem("rol") === "2") {
      // Utiliza el endpoint específico para el rol 2
      url = `restaurant_admin/list_my_restaurants?page=${value}&size=5&order_by=id&order=desc`;
    } else {
      // Utiliza el otro endpoint para cualquier otro rol
      url = `restaurants/?page=${value}&size=5&order_by=id&order=desc`;
    }

    makeRequest(
      "GET",
      url,
      null,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null,
      null,
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        console.log(response);
        const updateRestaurants = response.restaurants.map((restaurant) => ({
          ...restaurant,
          title: restaurant.name,
          title2: `${restaurant.name} Usuarios: ${restaurant.user_count}`,
        }));
        setRestaurants(updateRestaurants);
        setTotal(response.total);
        setPages(response.pages);
        setCurrentPage(response.currentPage);
        setIsLoaded(true);
      })
      .catch((error) => {
        console.log("Error al obtener los usuarios");
      });
  };


  // ── Callback: restaurante creado exitosamente ─────────────────────────────
  const handleRestaurantCreated = (newRestaurant) => {
    setMessageSnackBar("Restaurante creado exitosamente");
    setOpenSnackBar(true);
    // Recarga la lista volviendo a la página 1
    ChangePage(1);
  };

  // ── Callback: restaurante eliminado exitosamente ───────────────────────────
  const handleRestaurantDeleted = (deletedId) => {
    setOpenEdit(false);
    setMessageSnackBar("Restaurante eliminado correctamente");
    setOpenSnackBar(true);
    // Redirige al dashboard fuera del contexto del restaurante
    navigate("/");
  };

  // ── Navegar a la vista de planes (upgrade) ────────────────────────────────
  const handleGoToPlans = () => {
    navigate("/", { state: { openView: "Planes" } });
  };

  const action = (
    <>
      <IconButtonAnimated
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => {
          setOpenSnackBar(false);
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButtonAnimated>
    </>
  );

  const getCodeDay = () => {
    makeRequest(
      "GET",
      `restaurant_admin/restaurant_code/${restaurantId}`,
      null,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null,
      null,
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        setCodeDay(response.code);
        setOpenModalCode(true);
      })
      .catch((error) => {
        console.log("Error al obtener el codigo del dia");
      });
  };

  const shutDownOrTurnOn = (action) => {
    let url;
    if (action === "shutDown") {
      url = `restaurant_admin/code/${restaurantId}?require_code=false`;
    } else {
      url = `restaurant_admin/code/${restaurantId}?require_code=true`;
    }

    makeRequest(
      "PUT",
      url,
      null,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null,
      null,
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        if (action === "shutDown") {
          setMessageSnackBar("Codigo apagado");
        } else {
          setMessageSnackBar("Codigo encendido");
          setCodeDay(response.restaurant_new_code);
        }
        setOpenSnackBar(true);
        return; // Salir de la función si se encuentra un código de error
      })
      .catch((error) => {
        console.log("Error al obtener el codigo del dia");
      });
  };

  const handleToggle = (newStatus) => {
    setIsOn(newStatus);

    // Llama a la función shutDownOrTurnOn en función del nuevo estado
    shutDownOrTurnOn(newStatus ? "turnOn" : "shutDown");
  };

  const handleSwitchChange = (e) => {
    setPendingValue(e.target.checked); // guardamos el valor que intentó poner
    setConfirmOpen(true); // mostramos modal de confirmación
  };

  const confirmChange = () => {
    handleToggle(pendingValue); // ejecuta tu función original con el nuevo valor
    setConfirmOpen(false);
    setPendingValue(null);
  };

  const cancelChange = () => {
    setConfirmOpen(false);
    setPendingValue(null);
  };

  return (
    <>
      {isLoaded ? (
        <>
          {!openEdit && (
            <ListData
              title="Restaurantes"
              data={restaurants}
              setData={setRestaurants}
              edit={true}
              editMessage="Editar Restaurante"
              editFunction={(value, value2) => {
                setOpenEdit(true);
                setRestaurantId(value);
                setNameRestaurant(value2);
              }}
              page={page}
              setPage={setPage}
              changePage={ChangePage}
              pages={pages}
              total={total}
              currentPage={currentPage}
              // Solo visible para super-admin (rol 1) o dueño (is_owner) y si tiene has_billing_account
              create={(ownerMode || localStorage.getItem("rol") !== "2") && localStorage.getItem("has_billing_account") === "true"}
              createMessage="Crear Restaurante"
              createFunction={() => setCreateModalOpen(true)}
              nameColumn1="Restaurante"
              nameColumn2="Usuarios"
              nameColumn3="Acciones"
              EditIconPersonalized={EditIcon}
            />
          )}

          {/* ── Modal Crear Restaurante (nuevo) ─────────────────────────── */}
          <CreateRestaurantModal
            open={createModalOpen}
            onClose={() => setCreateModalOpen(false)}
            onSuccess={handleRestaurantCreated}
            onUpgradePlan={handleGoToPlans}
          />

          <CustomDialog
            open={openModalCode}
            onClose={() => setOpenModalCode(!openModalCode)}
          >
            <CustomDialogTitle>Tu código del Restaurante es</CustomDialogTitle>
            <CustomDialogContent>
              <Typography sx={{ fontSize: 15, color: "#374151" }}>{codeDay}</Typography>
            </CustomDialogContent>

            <CustomDialogActions>
              <Button onClick={() => setOpenModalCode(!openModalCode)} sx={{
                backgroundColor: "#E0E0E0",
                color: "#424242",
                "&:hover": {
                  backgroundColor: "#D5D5D5",
                }
              }}>
                Cerrar
              </Button>
              <div className="flex items-center">
                <span>{isOn ? "Encendido" : "Apagado"}</span>
                <Switch
                  checked={isOn}
                  onChange={handleSwitchChange}
                  color="primary"
                />
              </div>
            </CustomDialogActions>
          </CustomDialog>

          <CustomDialog open={confirmOpen} onClose={cancelChange}>
            <CustomDialogTitle>Confirmar acción</CustomDialogTitle>
            <CustomDialogContent>
              Al activar el requerimiento de código del restaurante, los
              pedidos en curso podrían verse afectados. ¿Deseas continuar?
            </CustomDialogContent>
            <CustomDialogActions>
              <Button onClick={cancelChange} sx={{
                backgroundColor: "#E0E0E0",
                color: "#424242",
                "&:hover": {
                  backgroundColor: "#D5D5D5",
                }
              }}>Cancelar</Button>
              <Button
                onClick={confirmChange}
                color="primary"
                variant="contained"
              >
                Confirmar
              </Button>
            </CustomDialogActions>
          </CustomDialog>

          {openEdit && (
            <>
              <Breadcrumbs
                aria-label="breadcrumb"
                sx={{ paddingLeft: 5, paddingTop: 5 }}
              >
                <Link
                  underline="hover"
                  color="inherit"
                  href="#"
                  onClick={() => setOpenEdit(false)}
                >
                  Restaurantes
                </Link>
                <Typography color="textPrimary">{nameRestaurant}</Typography>
              </Breadcrumbs>
              <Box
                sx={{
                  padding: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2.5, // Espacio entre elementos hijos
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 2.5,
                    paddingLeft: "25px",
                    paddingRight: "25px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <IconButtonAnimated
                      size="small"
                      aria-label="close"
                      color="inherit"
                      onClick={() => setOpenEdit(!openEdit)}
                    >
                      <img
                        src={ArrowCircleLeft}
                        alt="Notification"
                        style={{ width: "30px", height: "30px" }}
                      />
                    </IconButtonAnimated>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "white",
                        fontSize: 20,
                        fontFamily: "Arial",
                        fontWeight: "400",
                        wordWrap: "break-word",
                        "@media (max-width:425px)": {
                          display: "none",
                        },
                      }}
                    >
                      {nameRestaurant}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                    <SendButton onClick={() => getCodeDay()}>
                      Código de mesas
                    </SendButton>

                    {/* Eliminar restaurante — solo visible para dueños */}
                    {ownerMode && (
                      <Button
                        variant="contained"
                        startIcon={<DeleteForeverIcon />}
                        onClick={() => setDeleteModalOpen(true)}
                        sx={{
                          background: "linear-gradient(135deg, #F72E41, #c0001d)",
                          color: "#fff",
                          borderRadius: "12px",
                          fontWeight: 800,
                          fontSize: 13,
                          textTransform: "none",
                          boxShadow: "0 4px 12px rgba(247,46,65,0.35)",
                          py: 1,
                          px: 2,
                          "&:hover": { filter: "brightness(1.1)" },
                        }}
                      >
                        Eliminar restaurante
                      </Button>
                    )}
                  </Box>
                </Box>

                <CustomTabs tabs={tabs} />
              </Box>

              {/* ── Modal Eliminar Restaurante ─────────────────────────── */}
              <DeleteRestaurantModal
                open={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                restaurant={{ id: restaurantId, name: nameRestaurant }}
                onSuccess={handleRestaurantDeleted}
              />
            </>
          )}

          <Snackbar
            open={openSnackBar}
            autoHideDuration={2000}
            handleClose={() => {
              setOpenSnackBar(false);
            }}
            message={messageSnackBar}
            action={action}
          />
        </>
      ) : (
        <Box sx={{ height: "100vh" }} />
      )}
    </>
  );
}

export default ListRestaurants; // Exporta el componente ListUsersRestaurants
